import { useEntities } from "@hooks/useEntities";

export function useEntityWithMissingBusinessProfile() {
    const entities = useEntities({
        onlyBusiness: true,
        excludeMockEntities: true,
    });

    return entities.find((e) => !e.name || !e.legalType);
}
